export * from '@fluentui/react-focus';
//# sourceMappingURL=FocusZone.js.map